import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavLinkButton from "./button/NavLinkButton";

import logo from "../assets/logo.png";
import sidebarIcon from "../assets/icons/side-bar.png";
import crossIcon from "../assets/icons/cross.png";
import downRed from "../assets/icons/down-red.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [selectedButton, setSelectedButton] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const dropdownRef = useRef(null);

  const buttons = [
    { title: "Beranda", link: "/" },
    { title: "Layanan Kami", link: "/mitra-toko", icon: downRed },
  ];

  // 🔹 Tutup dropdown jika klik di luar area dropdown
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // 🔹 Handler untuk tombol navbar utama
  const handleButtonClick = (index, url) => {
    if (index === 1) {
      setIsDropdownVisible(!isDropdownVisible);
      setSelectedButton(index);
    } else {
      setSelectedButton(index);
      setIsDropdownVisible(false);
      setIsSidebarOpen(false);
      navigate(url);
    }
  };

  // 🔹 Handler klik item dropdown
  const handleDropdownClick = (url) => {
    setSelectedButton(null);
    setIsDropdownVisible(false);
    setIsSidebarOpen(false);
    navigate(url);
  };

  // 🔹 Toggle sidebar
  const toggleSidebar = () => {
    setIsDropdownVisible(false);
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleDaftarButtonClick = () => {
    setIsSidebarOpen(false);
    navigate("/daftar-sekarang");
  };

  return (
    <nav className="min-h-[120px] w-full flex items-center bg-white shadow-sm sticky top-0 z-50 font-medium text-pikkat-gray-1">
      <div className="container mx-auto flex justify-between items-center w-full">
        {/* Logo */}
        <img
          src={logo}
          alt="Pikkat Logo"
          className="max-w-[150px] max-h-[60px] cursor-pointer"
          onClick={() => navigate("/")}
        />

        {/* Desktop Navigation */}
        <div className="hidden lg:block">
          <div className="bg-pikkat-white flex items-center p-2 gap-3 rounded-lg relative scale-[80%] xl:scale-100">
            {buttons.map((label, idx) => (
              <div
                key={idx}
                className="relative"
                ref={idx === 1 ? dropdownRef : null}
              >
                <NavLinkButton
                  label={label.title}
                  isSelected={selectedButton === idx}
                  customStyle={
                    idx === 1 && isDropdownVisible ? "bg-red-500 text-white" : ""
                  }
                  onClick={() => handleButtonClick(idx, label.link)}
                  icon={label.icon}
                />

                {idx === 1 && isDropdownVisible && (
                  <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md">
                    <ul>
                      <li
                        className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(
                            "https://store.pikkat.company/",
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      >
                        Belanja
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                        onClick={() => handleDropdownClick("/mitra-toko")}
                      >
                        Mitra Toko
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                        onClick={() => handleDropdownClick("/mitra-pemasok")}
                      >
                        Mitra Pemasok
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Desktop CTA */}
        <div className="hidden lg:block">
          <button
            className="bg-[#E62129] text-white py-2 px-4 rounded-md hover:bg-red-600 transition"
            onClick={handleDaftarButtonClick}
          >
            Daftar Sekarang
          </button>
        </div>

        {/* Mobile Sidebar Button */}
        <div className="lg:hidden pr-2 cursor-pointer">
          <img
            src={sidebarIcon}
            alt="Menu"
            className="max-h-[50px]"
            onClick={toggleSidebar}
          />

          {/* Mobile Sidebar */}
          {isSidebarOpen && (
            <div className="fixed inset-0 bg-gray-800/50 z-40">
              <div className="fixed bg-white h-screen min-w-[50%] pl-2 right-0 top-0 z-50 animate-slideInFromRight overflow-y-scroll">
                {/* Close Button */}
                <div className="flex flex-row pt-5">
                  <button
                    className="text-pikkat-red"
                    onClick={toggleSidebar}
                    aria-label="Close sidebar"
                  >
                    <img src={crossIcon} alt="Close" />
                  </button>
                </div>

                {/* Sidebar Links */}
                <div className="flex flex-col px-4 pt-4 gap-4">
                  {buttons.map((label, idx) => (
                    <div
                      key={idx}
                      className="relative"
                      ref={idx === 1 ? dropdownRef : null}
                    >
                      <NavLinkButton
                        label={label.title}
                        isSelected={selectedButton === idx}
                        customStyle={
                          idx === 1 && isDropdownVisible
                            ? "bg-red-500 text-white"
                            : ""
                        }
                        onClick={() => handleButtonClick(idx, label.link)}
                        icon={label.icon}
                      />
                      {idx === 1 && isDropdownVisible && (
                        <div className="top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md">
                          <ul>
                            <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                window.open(
                                  "https://pikkat.com/",
                                  "_blank",
                                  "noopener,noreferrer"
                                );
                              }}
                            >
                              Belanja
                            </li>
                            <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() =>
                                handleDropdownClick("/mitra-toko")
                              }
                            >
                              Mitra Toko
                            </li>
                            <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() =>
                                handleDropdownClick("/mitra-pemasok")
                              }
                            >
                              Mitra Pemasok
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Sidebar CTA */}
                <div className="flex flex-col gap-3 justify-center items-center pt-4">
                  <button
                    className="bg-[#E62129] text-white py-2 px-4 rounded-md w-[80%] hover:bg-red-600 transition"
                    onClick={handleDaftarButtonClick}
                  >
                    Daftar Sekarang
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
